import axios, { isAxiosError, isCancel } from 'axios';
import { Cache } from './cache.js';

function withCache(cb, options) {
  const cache = new Cache(
    options
  );
  return (cacheKey, ...args) => {
    if (cacheKey === void 0) {
      const value = cb(...args);
      return {
        value,
        isStale: false,
        getRevalidated: () => value,
        getStaleWhileRevalidate: () => value,
        revalidate: () => value
      };
    }
    const cachedVal = cache.get(cacheKey);
    if (cachedVal == null ? void 0 : cachedVal.value) {
      throwOnError(cachedVal.value);
      return {
        isStale: cachedVal.isStale,
        value: cachedVal.value,
        revalidate: () => {
          const result = updateCache(
            cache,
            cacheKey,
            options == null ? void 0 : options.retainErrors,
            cb,
            ...args
          );
          throwOnError(result);
          return result;
        },
        getStaleWhileRevalidate: () => {
          if (cachedVal.isStale) {
            updateCache(cache, cacheKey, options == null ? void 0 : options.retainErrors, cb, ...args);
          }
          throwOnError(cachedVal.value);
          return cachedVal.value;
        },
        getRevalidated: () => {
          const result = cachedVal.isStale ? cachedVal.value : updateCache(cache, cacheKey, options == null ? void 0 : options.retainErrors, cb, ...args);
          throwOnError(result);
          return result;
        }
      };
    }
    const initialRes = cb(...args);
    cache.set(cacheKey, initialRes);
    if (isPromise(initialRes)) {
      initialRes.then((val) => {
        cache.set(cacheKey, val);
      }).catch((err) => {
        if (!(options == null ? void 0 : options.retainErrors)) {
          cache.delete(cacheKey);
        } else {
          cache.set(cacheKey, { __error: err });
        }
        if (isAxiosError(err)) {
          console.error(err.message, axios.getUri(err.config));
        }
        if (!isCancel(err) && !isAxiosError(err)) {
          console.error(err);
        }
      });
    }
    return {
      value: initialRes,
      isStale: false,
      revalidate: () => initialRes,
      getStaleWhileRevalidate: () => initialRes,
      getRevalidated: () => initialRes
    };
  };
}
function updateCache(cache, cacheKey, retainErrors, cb, ...args) {
  const returnValue = cb(...args);
  if (isPromise(returnValue)) {
    returnValue.then((val) => {
      cache.set(cacheKey, val);
    }).catch((err) => {
      if (retainErrors) {
        cache.set(cacheKey, { __error: err });
      }
      if (isAxiosError(err)) {
        console.error(err.message, axios.getUri(err.config));
      }
      if (!isCancel(err) && !isAxiosError(err)) {
        console.error(err);
      }
    });
  } else {
    cache.set(cacheKey, returnValue);
  }
  return returnValue;
}
function isPromise(result) {
  return result instanceof Promise;
}
function throwOnError(result) {
  if (typeof result === "object" && result != null && Object.prototype.hasOwnProperty.call(result, "__error")) {
    throw result.__error;
  }
}

export { withCache };
//# sourceMappingURL=withCache.js.map
